import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_FILTERS_FETCH_INCIDENTS_STATUS,
} from '../../../../actions/actionTypes';
import { translate } from '../../../../helpers/languageHelper';

export default fetchReducerGenerator(
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_FILTERS_FETCH_INCIDENTS_STATUS
);

const getIncidentStatusChildren = incidentStatuses =>
  incidentStatuses.map(({ value, literalKey }) => ({
    title: translate(literalKey),
    value: `incidentStatus_${value}`,
    key: `incidentStatus_${value}`,
  }));

const getAllIncidentsFiltersIncidentForProjection = responseData =>
  responseData
    .filter(({ incidentStatusGroupId }) => incidentStatusGroupId !== -1)
    .map(({ incidentStatusGroupId, literalKey, incidentStatuses }) => ({
      title: translate(literalKey),
      value: `incidentStatusGroup_${incidentStatusGroupId}`,
      key: `incidentStatusGroup_${incidentStatusGroupId}`,
      children: getIncidentStatusChildren(incidentStatuses),
    }));

export const getAllIncidentsFiltersIncidentStatusTreeData = state => {
  if (state.response && state.response.data) {
    return getAllIncidentsFiltersIncidentForProjection(state.response.data);
  } else {
    return [];
  }
};
